var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericButton',{staticClass:"whitespace-nowrap",attrs:{"theme":"lightBlue"},on:{"click":_vm.clickHandler}},[_c('span',{staticClass:"text-base font-bold font-mulish"},[_vm._v(" Reject all cookies ")])])}
var staticRenderFns = []

export { render, staticRenderFns }